export default __webpack_public_path__ + "static/media/logo-agis.ea101df8.png";